import { Configuration, LogLevel } from "@azure/msal-browser";

// Azure AD configuration from environment variables
export const azureConfig = {
  clientId: import.meta.env.VITE_AZURE_CLIENT_ID || "",
  tenantId: import.meta.env.VITE_AZURE_TENANT_ID || "",
  redirectUri:
    import.meta.env.VITE_AZURE_REDIRECT_URI || window.location.origin,
  apiScope:
    import.meta.env.VITE_AZURE_API_SCOPE ||
    `api://${import.meta.env.VITE_AZURE_CLIENT_ID}/access_as_user`,
} as const;

// Validate required Azure configuration
if (!azureConfig.clientId) {
  console.warn(
    "VITE_AZURE_CLIENT_ID is not set. Authentication will not work. Please set it in .env file."
  );
}

// Determine authority: single-tenant (specific tenant) or multi-tenant (organizations)
const authorityTenant = azureConfig.tenantId || "organizations";
const isMultiTenant = !azureConfig.tenantId;

if (isMultiTenant) {
  console.info(
    "[Auth] Multi-tenant mode: accepting logins from any Azure AD organization. Backend enforces tenant allowlist."
  );
} else {
  console.info(
    `[Auth] Single-tenant mode: restricted to tenant ${azureConfig.tenantId}`
  );
}

// MSAL Configuration
export const msalConfig: Configuration = {
  auth: {
    clientId: azureConfig.clientId,
    // Use v2.0 endpoint; multi-tenant uses "organizations" authority
    authority: `https://login.microsoftonline.com/${authorityTenant}/v2.0`,
    redirectUri: azureConfig.redirectUri,
    postLogoutRedirectUri: azureConfig.redirectUri,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: "localStorage", // Store tokens in localStorage for persistence
    storeAuthStateInCookie: false, // Set to true for IE11 or Edge support
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
        }
      },
      logLevel: import.meta.env.DEV ? LogLevel.Verbose : LogLevel.Error,
    },
  },
};

// Scopes for login request
// Include backend API scope + OpenID Connect scopes for user profile
export const loginRequest = {
  scopes: [azureConfig.apiScope, "openid", "profile", "email"],
};

// Scopes for token acquisition (API calls)
// Request token for backend API access
export const tokenRequest = {
  scopes: [azureConfig.apiScope],
  forceRefresh: false,
};
